type SearchParamsLike = { get: (name: string) => string | null } | null | undefined;

// Every window of a seasonal promo shares its coupons, so only flavor tells the windows apart.
// The promo link carries flavor and variant through to checkout.
export const getPromoAttribution = (
	searchParams: SearchParamsLike,
): { flavor?: string; variant?: string } => {
	const flavor = searchParams?.get('flavor');
	const variant = searchParams?.get('variant');
	return { ...(flavor ? { flavor } : {}), ...(variant ? { variant } : {}) };
};
